module.exports = __webpack_public_path__ + "static/hero2-9c4afca58ea957e7043ef04969662818.jpg";